import React from 'react';

interface OneNoteMonoIconProps {
  className?: string;
  style?: React.CSSProperties;
  /** Rendered width/height in px. Defaults to 16 (transparent text-button size). */
  size?: number;
}

/**
 * Monochrome OneNote icon (single `currentColor` silhouette).
 *
 * This is the line/mono variant — distinct from the colored brand
 * {@link OneNoteIcon} (white document + purple "N" block). Use it where the
 * glyph must inherit the surrounding text color, e.g. inside transparent text
 * buttons ("Kursnotizbuch reparieren", "Auf fehlende Notizbücher prüfen").
 *
 * Path adapted 1:1 from the legacy `OneNoteMonoIcon` of
 * `@fluentui/react-icons-northstar` (viewBox `2 2 16 16`).
 */
export const OneNoteMonoIcon: React.FC<OneNoteMonoIconProps> = ({
  className,
  style,
  size = 16,
}) => (
  <svg
    role="presentation"
    focusable="false"
    aria-hidden="true"
    viewBox="2 2 16 16"
    width={size}
    height={size}
    fill="currentColor"
    className={className}
    style={style}
  >
    <path d="M17.34,3a.68.68,0,0,1,.66.66V16.34a.68.68,0,0,1-.66.66H6.66A.68.68,0,0,1,6,16.34V14H2.66a.63.63,0,0,1-.46-.2.63.63,0,0,1-.2-.46V6.66a.63.63,0,0,1,.2-.46A.63.63,0,0,1,2.66,6H6V3.66A.68.68,0,0,1,6.66,3ZM5,9.34l1.89,3.28H8.12V7.38H7v3.35L5.14,7.38H3.88v5.24H5ZM17,16V14H15v2Zm0-3V11H15v2Zm0-3V8H15v2Zm0-3V4H7V6H9.34a.68.68,0,0,1,.66.66v6.68a.68.68,0,0,1-.66.66H7v2h7V7Z" />
  </svg>
);
